export const plainFetchSelectorCreator =
  (name) =>
  ({
    [name]: {
      fetchingInProgressSince,
      lastSuccessfulFetch,
      lastFailedFetch,
      ...data
    },
  }) => {
    const loading = !(lastSuccessfulFetch || lastFailedFetch);
    return {
      ...data,
      loading,
      refreshing: loading || fetchingInProgressSince,
    };
  };

export const createSliceSelector =
  (slice) =>
  ({ [slice.name]: data }) =>
    data;
